module.exports = __webpack_public_path__ + "img/icon_option_general@2x.f70cd954.png";